export enum ChipBackgroundColor {
  RED = 'red',
  GREEN = 'green',
  YELLOW = 'yellow',
}

export enum ChipLabelColor {
  RED = 'red',
  GREEN = 'green',
  YELLOW = 'yellow',
}
